<template>
  <div>
    <v-autocomplete
      :items="items"
      v-model="selectedAgent"
      :label="customLabel"
      item-text="name"
      item-value="id"
      @change="onChange"
      :outlined="outlinedInputs"
      :prepend-inner-icon="editable ? `mdi-account-edit` : `mdi-account`"
      :disabled="$apollo.loading"
      @click:prepend-inner="onAgentEdit"
      :loading="$apollo.loading"
      :search-input.sync="search"
      :dense="dense"
      :hide-details="hideDetails"
    >
      <template v-slot:item="data" v-if="showInfo">
        <v-list-item-content>
          <v-list-item-title> {{ data.item.name }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn small text icon color="indigo">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="grey lighten-1"
                  >mdi-information</v-icon
                >
              </template>
              <agent-info-tooltip :agent-id="data.item.id"></agent-info-tooltip>
            </v-tooltip>
          </v-btn>
        </v-list-item-action>
      </template>
    </v-autocomplete>
    <div v-if="debug">
      name: {{ agentName }} id: {{ agentId }} selected: {{ selectedAgent }}
    </div>
  </div>
</template>

<script>
import {
  ALL_AGENTS_BASIC_LIST,
  ALL_AGENTS_WITH_CURRENCY,
} from "../../../constants/graphql";
import { removeGQLTypename } from "../../../helpers";
import AgentInfoTooltip from "./AgentInfoTooltip";

export default {
  name: "AgentListSelect",

  props: {
    agentId: {
      type: String,
      default: () => "",
    },
    agentName: {
      type: String,
      default: () => "",
    },
    customLabel: {
      type: String,
      default: "Agent",
    },
    includeCurrency: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    editable: {
      type: Boolean,
      default: () => false,
    },
    showInfo: {
      type: Boolean,
      default: () => false,
    },
    ssSearch: {
      type: Boolean,
      default: () => true,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { AgentInfoTooltip },

  data() {
    return {
      debug: false,
      selectedAgent: this.value ? this.value : this.agentId,
      search: null,
      searchTimeout: null,
      searchDebounceTime: 700,
      nameFilter: null,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    items() {
      if (this.agents && this.agents.edges) {
        let list = this.agents.edges.map(removeGQLTypename);
        if (this.showInfo) {
          list = list.map((a) => ({
            ...a,
            name: `${a.name} (${a.companyCode})`,
          }));
        }
        if (this.agentName != "" && (this.value || this.agentId != "")) {
          const selected = list.find(
            (a) => a.id == this.value || a.id == this.agentId
          );

          return selected
            ? list
            : [
                {
                  name: this.agentName,
                  id: this.value ? this.value : this.agentId,
                },
                ...list,
              ];
        } else {
          return list;
        }
      } else {
        return [];
      }
    },
  },

  watch: {
    agentId(newVal) {
      this.selectedAgent = newVal;
    },
    value(newVal) {
      this.selectedAgent = newVal;
    },
    search(newVal) {
      if (this.ssSearch) {
        clearTimeout(this.searchTimeout);
        const selected = this.items.find((a) => a.id == this.selectedAgent);

        if (
          newVal &&
          newVal &&
          (!selected || (selected && selected.name != newVal))
        ) {
          this.searchTimeout = setTimeout(() => {
            this.nameFilter = newVal;
          }, this.searchDebounceTime);
        }
      }
    },
  },

  methods: {
    onChange(data) {
      if (typeof data == "string" && this.agents) {
        const selectedItem = this.items.find((item) => item.id == data);
        this.$emit("onSelect", selectedItem);
        this.$emit("input", data);
      }
    },
    onAgentEdit() {
      if (this.editable && this.selectedAgent) {
        const selectedItem = this.items.find(
          (item) => item.id == this.selectedAgent
        );
        this.$emit("edit", { ...selectedItem });
      }
    },
  },

  //ALL_AGENTS_BASIC_LIST
  apollo: {
    agents: {
      query() {
        return this.includeCurrency
          ? ALL_AGENTS_WITH_CURRENCY
          : ALL_AGENTS_BASIC_LIST;
      },
      variables() {
        return {
          filter: { not_in_use_eq: false, name_contains: this.nameFilter },
        };
      },
      // result({ data, loader, networkStatus }) {
      //   this.items = data.agents.edges.map((node) => ({ ...node.node }));
      // },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/AgentListSelect.vue